import Typography from "components/Typography"

import {
  DependencyItem,
  DependencyList,
  DependencyMeta,
  DependencyTitle,
  DependencyType,
  Wrapper
} from "./styled"

const DEFAULT_GUARDRAIL_MESSAGE =
  "Remove the linked News or Review items below before deleting this Home Video."

const dependencyTypeLabels: Record<string, string> = {
  HOME_VIDEO_REVIEW: "Home Video Review",
  HOME_VIDEO_REVIEWS: "Home Video Reviews",
  NEWS: "News"
}

const normalizeType = (type?: string) =>
  type
    ?.replace(/([a-z0-9])([A-Z])/gu, "$1_$2")
    .replace(/[\s-]+/gu, "_")
    .toUpperCase()

const formatDependencyType = (type?: string) => {
  const normalizedType = normalizeType(type)

  if (!normalizedType) {
    return "Linked Item"
  }

  if (dependencyTypeLabels[normalizedType]) {
    return dependencyTypeLabels[normalizedType]
  }

  return normalizedType
    .toLowerCase()
    .split(/[_\s]+/u)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(" ")
}

export interface GuardrailMessageDependency {
  id: string
  title: string
  type?: string
}

export interface GuardrailMessageProps {
  readonly dependencies: GuardrailMessageDependency[]
  readonly message?: string
}

const GuardrailMessage = ({
  dependencies,
  message
}: GuardrailMessageProps): JSX.Element => (
  <Wrapper>
    <Typography.Paragraph>
      {message ?? DEFAULT_GUARDRAIL_MESSAGE}
    </Typography.Paragraph>

    <DependencyList>
      {dependencies.map(({ id, title, type }) => (
        <DependencyItem key={`${type ?? "linked-item"}-${id}`}>
          <DependencyType>{formatDependencyType(type)}</DependencyType>

          <DependencyTitle>{title}</DependencyTitle>

          <DependencyMeta>{`ID: ${id}`}</DependencyMeta>
        </DependencyItem>
      ))}
    </DependencyList>
  </Wrapper>
)

export default GuardrailMessage
